import { IntlFormatters } from 'react-intl';

import Joi from 'joi';

export const clientCredentialsValidationSchema = ({
  formatMessage,
}: Pick<IntlFormatters, 'formatMessage'>) => {
  const patientId = formatMessage({
    id: 'developer_myprofile_clientcredential_patientpofile_userid',
  });

  const patientPassword = formatMessage({
    id: 'developer_myprofile_clientcredential_patientpofile_password',
  });

  const providerID = formatMessage({
    id: 'developer_myprofile_clientcredential_ehrpofile_userid',
  });

  return Joi.object({
    patientId: Joi.string()
      .trim()
      .messages({
        'string.empty': formatMessage(
          { id: 'generalForm_validation_required' },
          { field: patientId }
        ),
      }),
    patientPassword: Joi.string()
      .trim()
      .messages({
        'string.empty': formatMessage(
          { id: 'generalForm_validation_required' },
          { field: patientPassword }
        ),
      }),
    providerID: Joi.string()
      .trim()
      // eslint-disable-next-line
      .messages({
        'string.pattern.base': formatMessage(
          { id: 'generalForm_validation_allowed' },
          { field: providerID }
        ),
      }),
  });
};
